import gql from 'graphql-tag';

const UPDATE_SHARED_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!) {
    markSharedDevice(deviceSerialNo: $deviceSerialNo) {
      code
    }
  }
`;

export default UPDATE_SHARED_DEVICE;
